import { z } from 'zod';
import { isoDateSchema, moneyMinorSchema } from '../api';
import { ACCOUNT_TYPE, DOCTOR_PAYOUT_STATUS } from '../enums';
import { SUPPLIER_PAYMENT_MODE } from '../procurement';
export const upsertAccountSchema = z.object({
    code: z.string().trim().min(2).max(24),
    name: z.string().trim().min(2).max(200),
    type: z.enum(ACCOUNT_TYPE),
    parentId: z.string().uuid().nullable().optional(),
    /** Only postable accounts accept journal lines; headers exist to group. */
    isPostable: z.boolean().default(true),
    isActive: z.boolean().default(true),
});
export const journalLineSchema = z.object({
    accountId: z.string().uuid(),
    debitMinor: moneyMinorSchema.min(0).default(0),
    creditMinor: moneyMinorSchema.min(0).default(0),
    costCenterId: z.string().uuid().nullable().optional(),
    memo: z.string().trim().max(300).optional(),
});
export const postJournalSchema = z.object({
    branchId: z.string().uuid().nullable().optional(),
    entryDate: isoDateSchema,
    memo: z.string().trim().max(600).optional(),
    lines: z.array(journalLineSchema).min(2).max(200),
});
export const computePayoutSchema = z.object({
    doctorId: z.string().uuid(),
    periodStart: isoDateSchema,
    periodEnd: isoDateSchema,
    deductionsMinor: moneyMinorSchema.min(0).default(0),
    notes: z.string().max(1000).optional(),
});
export const PAYOUT_PAYMENT_MODE = SUPPLIER_PAYMENT_MODE;
export const payoutTransitionSchema = z
    .object({
    status: z.enum(DOCTOR_PAYOUT_STATUS),
    notes: z.string().max(1000).optional(),
    paidMode: z.enum(PAYOUT_PAYMENT_MODE).optional(),
    paidRef: z.string().trim().max(120).optional(),
})
    .superRefine((value, ctx) => {
    if (value.status !== 'paid')
        return;
    if (!value.paidMode)
        ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['paidMode'], message: 'Choose how the payout was paid' });
    if (value.paidMode && value.paidMode !== 'cash' && !value.paidRef) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['paidRef'], message: 'Enter the cheque, transfer or wallet reference' });
    }
});
//# sourceMappingURL=accounting.js.map